import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {YtbesprechungPageService} from '../services/ytbesprechung-page.service';
import {FlimmoMetaService} from '../../../core/services/flimmo-meta.service';
import {YTBesprechung} from '../../../generated-api';

@Injectable({
  providedIn: 'root'
})
export class YtbesprechungDetailsGuard implements CanActivate {
  constructor(private ytbesprechungPageService: YtbesprechungPageService, private flimmoMetaService: FlimmoMetaService, private router: Router) {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.ytbesprechungPageService.getYtBesprechung(next.params.id).pipe(catchError(err => {
      return of(null);
    })).pipe(map((value: YTBesprechung | null) => {
      if (value) {
        const prettyTitle = this.flimmoMetaService.prettifyUrl(value.title);
        if (next.params.title !== prettyTitle) {
          this.router.navigate(['ytbesprechung', value.id, prettyTitle]);
          return false;
        } else {
          return true;
        }
      } else {
        this.router.navigate(['']);
        return false;
      }
    }));
  }

}
